import { usePage } from "@inertiajs/react"
import { Ban, EyeOff, Flag, MoreVertical } from "lucide-react"
import { router } from "@inertiajs/react"

import ReportDialog from "@/components/report-dialog"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { typedPost } from "@/lib/typed-router"
import type { BlockUser, CreateContentHide } from "@/types/router-mutations"

interface ContentActionMenuProps {
  reportableType: string
  reportableId: number
  hideableType?: string
  hideableId?: number
  showBlock?: boolean
  blockUserId?: number
  isBlocked?: boolean
  onHide?: () => void
}

export default function ContentActionMenu({
  reportableType,
  reportableId,
  hideableType,
  hideableId,
  showBlock = false,
  blockUserId,
  isBlocked = false,
  onHide,
}: ContentActionMenuProps) {
  const { auth } = usePage<{ auth: { user: { id: number } | null } }>().props
  if (!auth?.user) return null

  const handleHide = () => {
    typedPost<CreateContentHide>(
      "/content_hides",
      {
        content_hide: {
          hideable_type: hideableType ?? reportableType,
          hideable_id: hideableId ?? reportableId,
        },
      },
      { preserveScroll: true },
    )
    onHide?.()
  }

  const handleBlock = () => {
    if (!blockUserId) return
    if (isBlocked) {
      router.delete(`/users/${blockUserId}/block`, { preserveScroll: true })
    } else {
      typedPost<BlockUser>(
        `/users/${blockUserId}/block`,
        {},
        { preserveScroll: true },
      )
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="text-muted-foreground p-1 hover:text-white">
          <MoreVertical className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <ReportDialog
          reportableType={reportableType}
          reportableId={reportableId}
        >
          <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
            <Flag className="mr-2 h-4 w-4" />
            Reportar
          </DropdownMenuItem>
        </ReportDialog>
        <DropdownMenuItem onSelect={handleHide}>
          <EyeOff className="mr-2 h-4 w-4" />
          Ocultar
        </DropdownMenuItem>
        {showBlock && blockUserId && (
          <DropdownMenuItem onSelect={handleBlock}>
            <Ban className="mr-2 h-4 w-4" />
            {isBlocked ? "Desbloquear" : "Bloquear"}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
